<script setup lang="ts">
import { CoIcon } from '@deputy/copilot2';
import { ref } from 'vue';

export interface Props {
  src: string;
  status?: string;
  size?: 'small' | 'large';
}
const props = withDefaults(defineProps<Props>(), {
  size: 'small',
});

const size = props.size === 'small' ? '30px' : '100px';
const imgLoaded = ref(false);
</script>

<template>
  <div class="__user-picture">
    <img
      :src="src"
      @load="imgLoaded = true"
      :class="{ hidden: !imgLoaded }"
      v-bind="$attrs"
      data-test-id="img"
    />

    <picture v-if="!imgLoaded" v-bind="$attrs" data-test-id="fallback">
      <CoIcon name="person" />
    </picture>

    <div :class="[status, '__status']"></div>
  </div>
</template>

<style scoped>
.hidden {
  display: none;
}

.__user-picture {
  position: relative;
}

img,
picture {
  --size: v-bind(size);
  border-radius: 50%;
}

img {
  width: var(--size);
  height: var(--size);
  max-height: var(--size);
  max-width: var(--size);
}

picture {
  height: var(--size);
  width: var(--size);
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--co-background-secondary);
}

.__status {
  width: 12px;
  height: 12px;
  border-radius: 8px;
  display: block;
  position: absolute;
  bottom: 1px;
  right: -1px;
  border: 2px solid var(--co-background-primary);
  display: none;
}

.__status--on-shift {
  display: block;
  background: #006360;
}

.__status--scheduled {
  display: block;
  background: var(--co-accent-primary);
}

.__status--on-break {
  display: block;
  background: var(--co-status-amber);
}
.__status--late {
  display: block;
  background: var(--co-status-red);
}
svg.co-icon {
  height: 75%;
  width: 75%;
  fill: #cccbd0;
}
</style>
